import { isEmpty } from 'lodash';
import { useRef } from 'react';
import { errorToast, warningToast } from '../../helpers/toastHelper';
import styles from './FileInput.module.scss';
import { removeExifFromMultipleFiles } from '../../helpers/jsHelper';

const FileInput = ({
  children,
  onFileSelect,
  onClick,
  accept,
  icon,
  multiple,
  Component = 'label',
  componentProps,
  allowFolders,
  inputProps,
  errorMessage,
  ...rest
}) => {
  const fileInputRef = useRef(null);

  const handleChange = async (e) => {
    let files = [...e.target.files];
    files = await removeExifFromMultipleFiles(files);
    
    const filesSelected = files.length > 0;

    if (accept) {
      // if folder is allowed we need to valiate folder file, if we accept files validation will be done by input
      files = files.filter((file) => {
        const correctFileType = !isEmpty(file.type) && accept.includes(file.type);
        if (correctFileType) return true;

        const arr = file.name.split('.');
        const extension = arr[arr.length - 1];
        return accept.includes(extension);
      });

      if (filesSelected && files.length === 0 && errorMessage) {
        warningToast(errorMessage);
        return;
      }
    }

    // TODO: file validation
    let file = files[0];

    if (!file) {
      return;
    }

    onFileSelect(multiple ? files : file);
  };

  const handleClick = (e) => {
    // reset previous file
    fileInputRef.current.value = null;
    onClick?.(e);
  };

  return (
    <Component onClick={handleClick} {...rest} {...componentProps}>
      <input
        ref={fileInputRef}
        type="file"
        onChange={handleChange}
        className={styles.input}
        accept={allowFolders ? undefined : accept}
        multiple={multiple}
        directory={allowFolders ? '' : undefined}
        webkitdirectory={allowFolders ? '' : undefined}
        {...inputProps}
      />
      {icon}
      {children}
    </Component>
  );
};

export default FileInput;
